import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import albumsData from '../data/Albums.json';
import PageTemplate from '../components/Common/PageTemplate';
import './Gallery.css';

const AlbumListPage = () => {
  const { t } = useTranslation();
  const [albums, setAlbums] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const albumsPerPage = 15; // Daha fazla albüm göster

  useEffect(() => {
    setAlbums(albumsData);
  }, []);

  const indexOfLastAlbum = currentPage * albumsPerPage;
  const indexOfFirstAlbum = indexOfLastAlbum - albumsPerPage;
  const currentAlbums = albums.slice(indexOfFirstAlbum, indexOfLastAlbum);

  const totalPages = Math.ceil(albums.length / albumsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const renderPaginationButtons = () => {
    const pageNumbers = [];
    const maxVisiblePages = 5;
    
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
    
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return (
      <nav className="pagination">
        <button
          onClick={() => paginate(currentPage - 1)}
          disabled={currentPage === 1}
          className="pagination-button"
        >
          ‹
        </button>
        {startPage > 1 && (
          <>
            <button
              onClick={() => paginate(1)}
              className="pagination-button"
            >
              1
            </button>
            {startPage > 2 && <span className="pagination-ellipsis">...</span>}
          </>
        )}
        {pageNumbers.map(number => (
          <button
            key={number}
            onClick={() => paginate(number)}
            className={`pagination-button ${currentPage === number ? 'active' : ''}`}
          >
            {number}
          </button>
        ))}
        {endPage < totalPages && (
          <>
            {endPage < totalPages - 1 && <span className="pagination-ellipsis">...</span>}
            <button
              onClick={() => paginate(totalPages)}
              className="pagination-button"
            >
              {totalPages}
            </button>
          </>
        )}
        <button
          onClick={() => paginate(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="pagination-button"
        >
          ›
        </button>
      </nav>
    );
  };

  return (
    <PageTemplate title={t('pages.photoAlbums.title')}>
      <div className="gallery-container">
        <div className="albums-grid-compact">
          {currentAlbums.map((album) => (
            <Link to={`/albums/${album.link}`} key={album.link} className="album-card-compact">
              <div className="album-image-container">
                <img src={album.img} alt={album.title} className="album-image-compact" />
                <div className="album-overlay">
                  <div className="album-overlay-content">
                    <span className="view-album">Albümü Görüntüle</span>
                  </div>
                </div>
              </div>
              <div className="album-info-compact">
                <h3 className="album-title-compact">{album.title}</h3>
                <p className="album-date-compact">
                  {new Date(album.date).toLocaleDateString('tr-TR', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </p>
              </div>
            </Link>
          ))}
        </div>
        {totalPages > 1 && renderPaginationButtons()}
      </div>
    </PageTemplate>
  );
};

export default AlbumListPage;
